import { Typography, Box } from '@mui/material';

export const LoginTitle = () => (
  <Box sx={{ textAlign: 'center', marginBottom: '10px' }}>
    <Typography
      variant="h4"
      sx={{
        fontWeight: 400,
        color: '#333',
        marginBottom: '8px',
        fontSize: { xs: '28px', md: '34px' },
      }}
    >
      Iniciar Sesión
    </Typography>
    <Typography
      variant="body2"
      sx={{
        color: '#999',
        fontSize: '14px',
      }}
    >
      Introduce tus credenciales para empezar a utilizar el sistema
    </Typography>
  </Box>
);
